import React from 'react';
import {createRoot} from 'react-dom/client';
import {PostHogProvider} from 'posthog-js/react';
import {collectWebVitals} from './collectWebVitals';
import 'configs/i18n';
import 'index.css';
import {setupSentry} from './setupSentry';
import {getFeatureFlags} from '@chekin/core';
import App from './App';

const IS_PRODUCTION_BUILD = import.meta.env.MODE === 'production';
if (IS_PRODUCTION_BUILD) {
  setupSentry();
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('The root element is not found');
}

const root = createRoot(container);

const IS_POSTHOG_ENABLED = getFeatureFlags('POSTHOG_TRACKING');

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  autocapture: false,
  capture_pageleave: false,
  capture_pageview: false,
  capture_performance: {web_vitals: false},
} as const;

const AppWithProviders = IS_POSTHOG_ENABLED ? (
  <PostHogProvider
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={posthogOptions}
  >
    <App />
  </PostHogProvider>
) : (
  <App />
);

root.render(AppWithProviders);

if (import.meta.env.VITE_APP_WITH_WEB_VITALS === 'true') {
  window.collectWebVitals = collectWebVitals;
}
